export function SpacerWidget(): JSX.Element {
  return <div></div>;
}
